import { connect } from 'react-redux'
import get from 'lodash/get';

import {
  getCarShortInfo as onGetCarShortInfo
} from '../../actions/carShortInfoActions'

const mapStateToProps = (state) => ({
  unitShortInfo: {
    dataState: state.unitShortInfo.dataState,
    drivers: get(state, ['unitShortInfo', 'data', 'drivers'], []),
    unitBrand: get(state, ['unitShortInfo', 'data', 'unitBrand', 'title'], ''),
    unitModel: get(state, ['unitShortInfo', 'data', 'unitModel', 'title'], ''),
    modelYear: get(state, ['unitShortInfo', 'data', 'unitRegistration', 'modelYear'], ''),
    registerNumber: get(state, ['unitShortInfo', 'data', 'unit', 'registerNumber'], ''),
    maintenance: get(state, ['unitShortInfo', 'data', 'maintenance'], ''),
    carId: get(state, ['unitShortInfo', 'data', 'carId'], ''),
  }
});

const mapDispatchToProps = {
  onGetCarShortInfo
}

const withCarShortInfo = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withCarShortInfo }